import { blogHolidays2023 } from "@/app/blog/(posts)/holidays_2023/blogHolidays2023.js";
import { blogVision2023 } from "@/app/blog/(posts)/vision_2023/blogVision2023.js";
import type { ArticleMetadata } from "@/components/articles/ArticleMetadata.js";
import { blogAccounts2024 } from "@/app/blog/(posts)/accounts_2024/blogAccounts2024.js";
import { blogPanda2024 } from "@/app/blog/(posts)/panda_2024/blogPanda2024.js";
import { blogTiming2024 } from "@/app/blog/(posts)/timing_2024/blogTiming2024.js";
import { blogMasters2024 } from "@/app/blog/(posts)/masters_2024/blogMasters2024.js";
import { blogReview2024 } from "@/app/blog/(posts)/review_2024/blogReview2024.js";
import { blogHalloween2024 } from "@/app/blog/(posts)/halloween_2024/blogHalloween2024.js";
import { blogMusic2024 } from "@/app/blog/(posts)/music_2024/blogMusic2024.js";
import { blogSolved } from "@/app/blog/(posts)/solved/blogSolved.js";
import { blogAchievements2025 } from "@/app/blog/(posts)/achievements_2025/blogAchievements2025";
// Withheld from the blog list until the new achievements are released. The page at
// /blog/achievements_2026 still exists; re-add the import + the entry below to publish.
// import { blogAchievements2026 } from "@/app/blog/(posts)/achievements_2026/blogAchievements2026.js";


export const blogPosts = [
    // blogAchievements2026, // Re-add when the new achievements are released.
    blogAchievements2025,
    blogSolved,
    blogMusic2024,
    blogHalloween2024,
    blogReview2024,
    blogMasters2024,
    blogTiming2024,
    blogPanda2024,
    blogAccounts2024,
    blogHolidays2023,
    blogVision2023,
];

export const latestBlogPost: ArticleMetadata = blogPosts[0];
